'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');

const reusableEmptyScope=Object.freeze({});
const _emptyArray=[];let

BaseDirective=function(){function BaseDirective(){_classCallCheck(this,BaseDirective)}BaseDirective.prototype.

















factory=function factory(){
const templateCount=[this.templateUrl,this.template].filter(function(t){return _.exists(t)}).length;
const directiveName=this.constructor.name;

const logFormatter=function(msg){return`[PULSAR] [${directiveName}] ${msg}`};

if(templateCount>1){
throw new Error(logFormatter('cannot specify both "templateUrl" and "template"'));
}

let scope={};
if(_.exists(this.optionalObjectBindings)){
_loopCheckAndAttachBindings(scope,this.optionalObjectBindings,'=?',logFormatter);
_loopCheckAndAttachBindings(scope,this.objectBindings,'=',logFormatter);
}else{
_loopCheckAndAttachBindings(scope,this.objectBindings,'=?',logFormatter);
}
_loopCheckAndAttachBindings(scope,this.textBindings,'@',logFormatter);
_loopCheckAndAttachBindings(scope,this.functionBindings,'&',logFormatter);

if(_.isEmpty(scope)){
scope=reusableEmptyScope;
}

return{
scope:scope,
restrict:this.restrict,
templateUrl:this.templateUrl,
template:this.template,
link:this.link};

};_createClass(BaseDirective,[{key:'objectBindings',get:function(){return _emptyArray}},{key:'textBindings',get:function(){return _emptyArray}},{key:'functionBindings',get:function(){return _emptyArray}},{key:'restrict',get:function(){throw new Error('please implement restrict')}}],[{key:'type',get:function(){return'directive'}}]);return BaseDirective}();


const _loopCheckAndAttachBindings=function(scope,bindingArray,bindingOption,logFormatter){
if(!bindingOption||!_.isString(bindingOption)){
throw new Error(`Binding option not supported: ${bindingOption}`);
}

for(const binding of bindingArray){
_warnIfNotCamelCase(binding,logFormatter);
scope[binding]=bindingOption;
}
};

const _warnIfNotCamelCase=function(bindingName,logFormatter){
const inCamelCase=_.camelCase(bindingName);

if(bindingName!==inCamelCase){
console.error(logFormatter(`Binding not in camel case, are you sure this was intended? Use hyphenated version in markup only: ${bindingName}`));
}
};

module.exports=BaseDirective;
//# sourceMappingURL=baseDirective.js.map
